import { Profile, ProfileDataResponse } from "../../models/Profile";

/**
 * Parses the profile response data and returns a Profile object.
 */
export const parseProfileResponse = ({ firstName, lastName, email, profilePicture, username, timezone, language, subscriptionType, emergency, parent }: ProfileDataResponse): Profile => {
    return {
        studentInformation: { firstName, lastName, email, profilePicture },
        accountInformation: { username, timezone, language, subscriptionType },
        emergencyInformation: emergency,
        parentInformation: parent,
    }
}